import { RangeFilter } from '../../../shared/models/range.model';
import { Serializable } from '../../../core/models/serializable';

export class PortfolioCustomerDetailsFilterModel
  implements Serializable<PortfolioCustomerDetailsFilterModel>
{
  fromObject(object: any): PortfolioCustomerDetailsFilterModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    let result = {
      CreateDate: this.createDate,
      Keyword: this.customer,
      IsHiddenZeroAnnouncement: this.isHiddenZeroAnnouncement,
      IsHiddenZeroTotalDebt: this.isHiddenZeroTotalDebt,
    };
    return result;
  }

  createDate: RangeFilter<Date>;
  customer: string;
  isHiddenZeroAnnouncement: boolean;
  isHiddenZeroTotalDebt: boolean;

  constructor() {
    this.createDate = new RangeFilter(null, null);
    this.customer = null;
    this.isHiddenZeroAnnouncement = false;
    this.isHiddenZeroTotalDebt = false;
  }
}
